import { ensureValidVersion, redirectToHomeIfNoAccessGranted } from '@/market-data/router/guards';

const LayoutMarketData = () => import('@/market-data/layouts/layout-market-data.vue');
const MarketDataPage = () => import('@/market-data/pages/market-data.vue');
const MarketDataSettingsLayout = () => import('@/market-data/layouts/layout-market-data-settings.vue');
const MarketDataColumnsPage = () => import('@/market-data/pages/columns.vue');
const MarketDataVersionsPage = () => import('@/market-data/pages/versions.vue');

export const marketDataRoutes = [
  {
    path: '/market-data',
    component: LayoutMarketData,
    beforeEnter: redirectToHomeIfNoAccessGranted,
    children: [
      {
        path: '',
        name: 'market-data',
        component: MarketDataPage,
        beforeEnter: ensureValidVersion,
      },
      {
        path: 'settings',
        name: 'market-data-settings',
        redirect: { name: 'market-data-settings-columns' },
        component: MarketDataSettingsLayout,
        children: [
          {
            path: 'columns',
            name: 'market-data-settings-columns',
            component: MarketDataColumnsPage,
          },
          {
            path: 'versions',
            name: 'market-data-settings-versions',
            component: MarketDataVersionsPage,
          },
        ],
      },
    ],
  },
];
